import { Box } from "@mui/material";
import { StatusStackedBarChart, useAlertSourceStatusCharts } from "./alertStatusChart";

interface AlertsActionsMetricsProps {
  startDate: string;
  endDate: string;
  companyId: number | null;
}

export default function AlertsActionsMetrics(props: AlertsActionsMetricsProps) {
  const { data, loading } = useAlertSourceStatusCharts("actions", ["ethoca", "cdrn", "rdr"], props);
  const ethocaData = data.ethoca ?? null;
  const cdrnData = data.cdrn ?? null;
  const rdrData = data.rdr ?? null;

  const hasAnyData =
    (ethocaData && ethocaData.summary.total > 0) ||
    (cdrnData && cdrnData.summary.total > 0) ||
    (rdrData && rdrData.summary.total > 0);
  if (!loading && !hasAnyData) {
    return null;
  }

  const rowSx = { display: "flex", gap: 3, flexWrap: { xs: "wrap", md: "nowrap" }, alignItems: "flex-start" } as const;

  return (
    <Box sx={{ mt: 3, display: "flex", flexDirection: "column", gap: 3 }}>
      <Box sx={rowSx}>
        <StatusStackedBarChart title="Ethoca All Actions" data={ethocaData} loading={loading} />
        <StatusStackedBarChart title="CDRN All Actions" data={cdrnData} loading={loading} />
      </Box>
      <Box sx={rowSx}>
        <StatusStackedBarChart title="RDR All Actions" data={rdrData} loading={loading} />
        <Box sx={{ flex: 1, display: { xs: "none", md: "block" } }} />
      </Box>
    </Box>
  );
}
